import { SAFE_MED_PRODUCT_TYPE_KEY, FeatureFlagNames } from 'constants/app.constant';
import { useSelector } from 'react-redux';
import { courseSelectors } from 'reports/cw/redux/ducks/courses';
import { appSelectors } from 'redux/ducks/app';
import { isFeatureEnabled } from 'services/feature-flag.service';
var useSafeMedCourse = function () {
    var featureFlags = useSelector(appSelectors.getFeatureFlags);
    var isCWSafeMedFFEnabled = isFeatureEnabled(featureFlags, FeatureFlagNames.USPD_HESI_SAFE_MED_ENABLED);
    var courseSection = useSelector(courseSelectors.getCourseSectionInfo);
    var _a = (courseSection || {}).entitlements, entitlements = _a === void 0 ? [] : _a;
    var isSafeMedCourse = entitlements.some(function (_a) {
        var evolveProductTypeKey = _a.evolveProductTypeKey;
        return evolveProductTypeKey === SAFE_MED_PRODUCT_TYPE_KEY;
    }) && isCWSafeMedFFEnabled;
    return {
        isSafeMedCourse: isSafeMedCourse
    };
};
export default useSafeMedCourse;
